export default {
  user_success_update: "个人资料修改成功",
  custom_mes_email: "邮箱格式不正确",
  custom_mes_verification: "验证码不正确",
  custom_mes_phone: "手机号码不能为空",
  userinfo_msg_email: "请输入正确的邮箱",
  userinfo_msg_verification: "验证码不能为空",
  userinfo_msg_phone: "请输入正确的手机号码",
  userinfo_msg_name: "姓名不能为空",
  userinfo_btn: "提交",
  userinfo_email: "邮箱",
  userinfo_verification_code: "验证码",
  userinfo_phone: "手机号码",
  userinfo_userName: "姓名",
  userinfo_title: "补充个人资料",
  expo_notice: "展会公告",
  dock_customer_service: "客服",
  dock_feedback: "反馈",
  dock_top: "顶部",
  btn_switch_expo: "切换展会",
  schedule: "展会时间安排",
  self_service: "自助服务",
  self_service_desc: "多功能自助服务，满足您的一切需求",
  special_booth: "特装服务",
  normal_booth: "标摊服务",
  modify_info: "修改资料",
  change_pass: "修改密码",
  login: "登录",
  register: "注册",
  account_info: "账户信息",
  booth_info: "展位信息",
  check_drawing: "审图",
  mandatory_fee: "必缴费用",
  non_booth: "暂无展位",
  bind_booth_tips1: "您可以通过审图或者缴纳固定费用绑定展位",
  bind_booth_tips2: "您的展位",
  bind_link: "绑定",
  normal_booth_tips: "标摊不需要审图",
  contact_info: "项目联系人",
  download_info: "资料下载",
  download: "下载",
  feedback_title: "意见反馈",
  feedback_placeholder: "请输入您的宝贵意见",
  expo_name_input: "展会名称",
  expo_name_input_palceholder: "请输入展会名称",
  expo_start_time_input: "开展时间",
  expo_start_time_input_placeholder: "请输入选择时间",
  change_expo_tips: "若您预订过的展会已关闭预订，您可以查看",
  change_expo_tips_link: "历史订单",
  download_error_tips: "请选择需要下载的资料",
  download_confirm: "确定下载已选中的资料吗",
  feedback_error_tips: "请输入您的意见",
  feedback_success_tips: "感谢您的支持与反馈",
  miss_tel_msg: "当前暂无联系方式，请联系主场配置",
  miss_downlaodData_msg: "暂无资料可供下载",
  insufficient_authority: "您尚未登录，无法查看，去",
  展会公告: "展会公告",
  查看更多: "查看更多",
  从: "从",
  至: "至",
  详情: "查看详情",
  公告详情: "公告详情",
  当前展会暂未公布时间安排: "当前展会暂未公布时间安排"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/main.js